import Vue from 'vue'
import VtDatePicker from '@/components/common/VtDatePicker.vue'
Vue.component('VtDatePicker', VtDatePicker)
